import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,{staticClass:"pa-0 MapContainer"},[_c(VRow,{attrs:{"no-gutters":""}},[_c(VCol,{attrs:{"cols":"12"}},[_c('GmapMap',{ref:"googleMapRef",staticClass:"MapContainer",staticStyle:{"position":"absolute","top":"50px","left":"0","bottom":"0","width":"100%"},attrs:{"center":_vm.center,"zoom":_vm.zoomLevel}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }